import { stdObject } from "../../../data/types/stdObject";
import { getIssueKey } from "../../../utils/getIssueKey";

export const updateIssue = (
  index: number,
  type: number,
  value: string,
  docValues: stdObject,
  setDocValues: any,
) => {
  let tempData = docValues;
  tempData.updated = true;
  tempData.issues[index][getIssueKey(type)] = value;
  setDocValues({ ...tempData });
};
